import * as React from 'react';
import { IFilterProps } from '../../../../../shop-ui/components/search-page/interfaces';
import Accordion from '../../../../../shop-ui/components/Accordion';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import useMultipleSelectFilter from '../../../../../shop-ui/components/search-page/hooks/useMultipleSelectFilter';
import MaterialFilterOptions from './MaterialFilterOptions';

const MaterialFilter: React.FunctionComponent<IFilterProps> = props => {
    const { options } = props;
    const selectedOptions = props.options
        .filter(option => option.selected);
    const [onToggleItem, displaySelectedFilterOptions] = useMultipleSelectFilter(props.name, selectedOptions, props.dispatch);

    return (
        <Accordion
            label={translate('Material', 'helmet-buyer-guide')}
            headerContent={displaySelectedFilterOptions()}
            hideHeaderContentOnCollapsed={true}
            isScrollToCurrentOnCollapsed={true}
        >
            <div className={`material-filter`}>
                {displaySelectedFilterOptions()}
                <div className={`scroll-selection`}>
                    <MaterialFilterOptions
                        optionList={options}
                        onToggleItem={onToggleItem}
                    />
                </div>
            </div>
        </Accordion>
    );
}

export default MaterialFilter;
